import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { conversationalChatStoreSelectorKey } from './conversational-chat.state';
import {
  conversationalChatMetaReducer,
  conversationalChatReducer,
} from './reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(
      conversationalChatStoreSelectorKey,
      conversationalChatReducer,
      { metaReducers: [conversationalChatMetaReducer] }
    ),
  ],
})
export class ConversationalChatStoreModule {}
